import Breadcrumbs from "components/breadcrumbs";
import Container from "components/container";
import H1 from "components/libs/title";
import { FC } from "react";
import AnimatedPage from "utils/animatedPage";
import AlbertSad from '../../../assets/images/albert/status/Sad.svg';
import st from './style.module.css';

const Maintenance: FC = () => {

    //!COMPONENT RETURN
    return (
        <AnimatedPage>
            <Breadcrumbs />
            <Container>
                <div className={st.container}>
                    <div className={st.icon}>
                        <img src={AlbertSad} height={"auto"}></img>
                    </div>
                    <H1>Maintenance en cours</H1>
                    <div className={st.content}>Mon ami <strong>Albert</strong> est en maintenance temporaire.</div>
                    <div className={st.content}>Merci de réessayer dans un instant.</div>
                    <div className={st.loader}></div>
                    {/* <button className={st.retryBtn} onclick="location.reload()">Réessayer maintenant</button> */}
                </div>
            </Container>
        </AnimatedPage>
    );
};

export default Maintenance;